<template>
    <span class="cursor-pointer" :class="[$props.className]" @click="editItem">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"></path></svg>
    </span>
</template>
<script>
export default {
    name: 'EditButton',
    emits: ['edit'],
    props: {
        className: {
            type: String,
            default: ''
        },
        itemId: {
            type: [Number, String],
            required: true
        }
    },
    methods: {
        editItem() {
            this.$emit('editItem', this.$props.itemId)
        }
    }
}
</script>